import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';
import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';

export const LoginData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.SIGN_IN, data);
  return response;
};

export const adminLogOut = async () => {
  const response = await SmartLockApiCallerInstance.post(SMART_LOCK_API_ENDPOINTS.SIGN_IN);
  return response;
};

export const ResetPassword = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.RESET_PASSWORD,
    data
  );
  return response;
};

export const PasswordOtpGenerate = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.GENERATE_OTP,
    data
  );
  return response;
};

export const CognitoAuthenticate = async () => {
  const response = SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.COGNITO_SESSION_TOKEN}`
  );
  return response;
};
